/** Маппинг русских названий направлений на английские идентификаторы */
export const DIRECTION_NAME_TO_SLUG: Record<string, string> = {
  Футбол: 'football',
  Баскетбол: 'basketball',
  Плавание: 'swimming',
  Волейбол: 'volleyball',
  Гимнастика: 'gymnastics',
  Шахматы: 'chess',
  Хоккей: 'hockey',
  Теннис: 'tennis',
  Бокс: 'boxing',
  Лыжи: 'skiing',
  Бег: 'running',
}

export const DIRECTION_ICONS: Record<string, string> = {
  football: 'i-local-football',
  basketball: 'i-local-basketball',
  swimming: 'i-local-swimming',
  volleyball: 'i-local-volleyball',
  gymnastics: 'i-local-gymnastics',
  chess: 'i-local-chess',
  hockey: 'i-local-hockey',
  tennis: 'i-local-tennis',
  boxing: 'i-local-boxing',
  skiing: 'i-local-skiing',
  running: 'i-local-running',
}

/** Пути к иллюстрациям направлений (PNG из Figma, без фона) */
export const DIRECTION_ILLUSTRATIONS: Record<string, string> = {
  football: '/images/directions/football.png',
  basketball: '/images/directions/basketball.png',
  swimming: '/images/directions/swimming.png',
  volleyball: '/images/directions/volleyball.png',
  gymnastics: '/images/directions/gymnastics.png',
  chess: '/images/directions/chess.png',
  hockey: '/images/directions/hockey.png',
  tennis: '/images/directions/tennis.png',
  boxing: '/images/directions/boxing.png',
  skiing: '/images/directions/skiing.png',
  running: '/images/directions/running.png',
}

export function getDirectionIcon(
  dir?: { name?: string; slug?: string } | null,
): string {
  if (!dir) return ''

  const slug = dir.slug
  if (slug) {
    const icon = DIRECTION_ICONS[slug]
    if (icon) return icon
  }
  const name = dir.name

  if (name) {
    const mappedSlug = DIRECTION_NAME_TO_SLUG[name]
    if (mappedSlug) {
      const icon = DIRECTION_ICONS[mappedSlug]
      if (icon) return icon
    }
  }
  return ''
}

/**
 * Убирает цветную подложку из SVG-иконки направления с бэка
 * и перекрашивает глиф в currentColor.
 * Сохраняет исходный viewBox, иначе глиф обрезается при scale до 16×16.
 */
export function toPlainDirectionSvg(svg?: string | null): string {
  if (!svg?.trim()) return ''

  const openTag = svg.match(/<svg\b[^>]*>/i)?.[0] ?? ''
  const existingViewBox = openTag.match(/viewBox\s*=\s*["']([^"']+)["']/i)?.[1]
  const origW = openTag.match(/\swidth\s*=\s*["'](\d+(?:\.\d+)?)["']/i)?.[1]
  const origH = openTag.match(/\sheight\s*=\s*["'](\d+(?:\.\d+)?)["']/i)?.[1]
  const viewBox =
    existingViewBox || (origW && origH ? `0 0 ${origW} ${origH}` : '0 0 32 32')

  let removedBg = false

  let result = svg.replace(/<path\b[^>]*\/?>/gi, (match) => {
    if (removedBg) return match

    const fill = match.match(/fill\s*=\s*["']([^"']+)["']/i)?.[1]
    if (!fill || fill.toLowerCase() === 'none') return match

    // Подложка — заливка без stroke; глиф обычно stroke или fill="white"
    const hasStroke = /stroke\s*=/i.test(match)
    const isWhiteFill = /^(white|#fff(?:fff)?|#ffffff)$/i.test(fill.trim())
    if (hasStroke || isWhiteFill) return match

    removedBg = true
    return ''
  })

  result = result
    .replace(/\swidth="[^"]*"/gi, '')
    .replace(/\sheight="[^"]*"/gi, '')
    .replace(/\sviewBox="[^"]*"/gi, '')
    .replace(/stroke="white"/gi, 'stroke="currentColor"')
    .replace(/fill="white"/gi, 'fill="currentColor"')
    .replace(/stroke="#(?:[fF]{3}|[fF]{6}|[fF]{8})"/g, 'stroke="currentColor"')
    .replace(/fill="#(?:[fF]{3}|[fF]{6}|[fF]{8})"/g, 'fill="currentColor"')
    .replace(/\sstroke-opacity="[^"]*"/gi, '')
    .replace(/\sfill-opacity="[^"]*"/gi, '')
    .replace(
      /<svg\b/i,
      `<svg width="16" height="16" viewBox="${viewBox}" style="display:block;width:16px;height:16px;flex-shrink:0"`,
    )

  return result
}

export function getDirectionIllustration(name: string | undefined): string {
  if (!name) return ''

  return (
    DIRECTION_ILLUSTRATIONS[
      DIRECTION_NAME_TO_SLUG[name] as keyof typeof DIRECTION_ILLUSTRATIONS
    ] || ''
  )
}
